export const faqs = [
  {
    q: "笨狗漫画网的排行榜多久更新一次？",
    a: "我们的热门榜、评分榜与新作榜每日零点自动更新，综合热度、评分与讨论量加权计算，让你随时掌握最值得追的作品风向。",
  },
  {
    q: "作品评分是怎么来的？",
    a: "评分来自社区用户的真实投票，每部作品只计入有效账号的打分，并结合追更完成度做校准，尽量避免恶意刷分，让评分更客观可信。",
  },
  {
    q: "如何把喜欢的作品加入书单？",
    a: "在作品详情或书单页面点击「收藏到书单」，即可按主题整理你的追更列表，方便随时回来查看进度与更新。",
  },
  {
    q: "哪些作品可以免费追读？",
    a: "站内绝大多数作品均可免费阅读，部分热门新番会提供限时免费章节。你可以在排行榜和推荐中筛选「免费」标签快速查找。",
  },
  {
    q: "在社区讨论区发帖有什么规范？",
    a: "请围绕漫画内容理性讨论，避免剧透未标注、攻击他人或刷屏广告。违规内容会被管理员处理，共同维护良好的追漫氛围。",
  },
];